var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveDisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3965 1.42617L13.882 0.911675C13.8584 0.888155 13.832 0.861695 13.7967 0.838175C13.3557 0.432455 12.7559 0.200195 12.1444 0.200195H2.04848C1.03418 0.200195 0.199219 1.03221 0.199219 2.04945V20.3509C0.199219 21.3682 1.03124 22.2002 2.04848 22.2002H17.4717C18.4889 22.2002 19.321 21.3682 19.321 20.3509V7.37967C19.321 6.72993 19.0622 6.09195 18.5977 5.63919L14.3965 1.42617ZM12.1415 1.41441C12.4472 1.41441 12.753 1.53789 13.0235 1.77015L13.3528 2.09943V5.32167C13.3528 5.39517 13.2293 5.50395 13.0352 5.50395H6.49375C6.29677 5.50395 6.17623 5.39517 6.17623 5.32167V1.40265H12.1415V1.41441ZM5.12371 20.9654V13.4067C5.12371 13.0891 5.38243 12.8304 5.69995 12.8304H13.8202C14.1377 12.8304 14.3965 13.0891 14.3965 13.4067V20.9654H5.12371ZM18.1097 20.3392C18.1097 20.6949 17.8392 20.9625 17.4864 20.9625H15.6371V13.4037C15.6371 12.41 14.8286 11.6044 13.8379 11.6044H5.71759C4.72387 11.6044 3.91832 12.4129 3.91832 13.4037V20.9625H2.0573C1.70156 20.9625 1.43402 20.692 1.43402 20.3392V2.03769C1.43402 1.68195 1.7045 1.41441 2.0573 1.41441H4.96201V5.33343C4.96201 6.10371 5.66173 6.74169 6.50551 6.74169H13.047C13.8937 6.74169 14.5905 6.10371 14.5905 5.33343V3.33717L17.7628 6.50943C17.995 6.72993 18.1185 7.06215 18.1185 7.37967V20.3392H18.1097Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveDisk);
export default __webpack_public_path__ + "static/media/saveDisk.0b0db27e457b4d3637d71d40b71c2819.svg";
export { ForwardRef as ReactComponent };